<particle-workflow-wizard [workflowId]="workflowId"
                          [apiEndpointKey]="apiEndpointKey"
                          (GridCellValueChanged)="onGridCellValueChange($event)">

</particle-workflow-wizard>
